const routes = {
	root: '',
	secondPage: 'secondPage',
	notfound: '*',
};

export default routes;
